import React, {FC, ReactNode} from 'react';
import {Col, Row} from 'antd';
import {FloatedCol} from '@joyrideautos/web-common-components/src/components/FloatedCol';
import {RowProps} from 'antd/es/row';

// We use it for headers on top of cards' grid like 'Upcoming vehicles'

interface FixedHeaderRowProps extends RowProps {
    left?: ReactNode;
    right?: ReactNode;
}

export const FixedHeaderRow: FC<FixedHeaderRowProps> = ({left, right, ...rest}) => {
    return (
        <Row align="middle" {...rest}>
            <FloatedCol xs={24} sm={24} md={24} lg={16} xl={16} justify="start">
                <Col>{left}</Col>
            </FloatedCol>
            <FloatedCol xs={24} sm={24} md={24} lg={8} xl={8} justify="end">
                <Col>{right}</Col>
            </FloatedCol>
        </Row>
    );
};
